if(!customElements.get('hero-slider')) {
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.isInitialized = false;
      this.initAttempts = 0;
      this.maxInitAttempts = 5;

      // NON inizializzare nel constructor - troppo presto!
      // this.initSlider(); // RIMOSSO

      this.setupEventListeners();
    }

    setupEventListeners() {
      // Shopify Design Mode
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        window.addEventListener('shopify:section:load', e => {
          this.destroySlider();
          this.initAttempts = 0; // Reset tentativi
          setTimeout(() => this.attemptInit('shopify-section-load'), 100);
        });
      }

      // Shopify Block Select
      window.addEventListener('shopify:block:select', e => {
        const selectedSlideIndex = +e.target.dataset.index;
        if (this.slider && this.isInitialized) {
          this.slider.slideTo(selectedSlideIndex, 600);
        } else {
          // Se lo slider non è ancora inizializzato, salva l'indice per dopo
          this.pendingSlideIndex = selectedSlideIndex;
        }
      });
    }

    connectedCallback() {
      console.log('Hero Slider connesso al DOM');
      
      // Strategia multipla di inizializzazione
      this.setupMultipleInitStrategies();
    }

    setupMultipleInitStrategies() {
      // Strategia 1: Immediate se DOM ready
      if (document.readyState === 'complete') {
        this.attemptInit('immediate-complete');
      }

      // Strategia 2: DOMContentLoaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.attemptInit('DOMContentLoaded');
        });
      } else {
        // DOM già caricato
        this.attemptInit('DOM-already-loaded');
      }

      // Strategia 3: Window load
      window.addEventListener('load', () => {
        this.attemptInit('window-load');
      });

      // Strategia 4: Timeout aggressivi
      setTimeout(() => this.attemptInit('timeout-50'), 50);
      setTimeout(() => this.attemptInit('timeout-100'), 100);
      setTimeout(() => this.attemptInit('timeout-300'), 300);
      setTimeout(() => this.attemptInit('timeout-1000'), 1000);

      // Strategia 5: Intersection Observer
      this.setupIntersectionObserver();

      // Strategia 6: MutationObserver per cambiamenti DOM
      this.setupMutationObserver();
    }

    setupIntersectionObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.isInitialized) {
            console.log('Hero slider ora visibile, tentativo inizializzazione');
            this.attemptInit('intersection-observer');
          }
        });
      }, {
        rootMargin: '50px',
        threshold: 0.1
      });

      observer.observe(this);
    }

    setupMutationObserver() {
      const mutationObserver = new MutationObserver((mutations) => {
        let shouldAttemptInit = false;
        
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            const addedSlides = Array.from(mutation.addedNodes).some(node => 
              node.nodeType === 1 && (
                node.classList.contains('swiper-slide') ||
                node.querySelector && node.querySelector('.swiper-slide')
              )
            );
            
            if (addedSlides && !this.isInitialized) {
              shouldAttemptInit = true;
            }
          }
        });

        if (shouldAttemptInit) {
          this.attemptInit('mutation-observer');
        }
      });

      mutationObserver.observe(this, {
        childList: true,
        subtree: true
      });
    }

    attemptInit(trigger) {
      //console.log(`[Hero Slider] Tentativo inizializzazione da: ${trigger}`);
      
      if (this.isInitialized) {
        //console.log('[Hero Slider] Già inizializzato, skip');
        return;
      }

      if (this.initAttempts >= this.maxInitAttempts) {
        console.warn('[Hero Slider] Raggiunto numero massimo di tentativi');
        return;
      }

      this.initAttempts++;

      // Verifica condizioni preliminari
      if (!this.isReadyForInit()) {
        //console.log(`[Hero Slider] Non pronto (tentativo ${this.initAttempts})`);
        
        // Retry con backoff
        const retryDelay = Math.min(100 * Math.pow(2, this.initAttempts), 2000);
        setTimeout(() => {
          this.attemptInit(`${trigger}-retry-${this.initAttempts}`);
        }, retryDelay);
        return;
      }

      this.initSlider();
    }

    isReadyForInit() {
      // Verifica connessione DOM
      if (!this.isConnected) {
        //console.log('[Hero Slider] Non connesso al DOM');
        return false;
      }

      // Verifica presenza slide
      const slides = this.querySelectorAll('.swiper-slide');
      if (slides.length === 0) {
        //console.log('[Hero Slider] Nessuna slide trovata');
        return false;
      }

      // Verifica dimensioni elemento
      const rect = this.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) {
        //console.log('[Hero Slider] Elemento senza dimensioni');
        return false;
      }

      // Verifica caricamento immagini critiche
      const heroImages = this.querySelectorAll('.hero__image img, .hero__media img');
      for (let img of heroImages) {
        if (img.loading !== 'lazy' && !img.complete && img.naturalHeight === 0) {
          //console.log('[Hero Slider] Immagini hero non ancora caricate');
          return false;
        }
      }

      // Verifica elementi di navigazione se presenti
      const pagination = this.querySelector('.swiper-pagination');
      const nextButton = this.querySelector('.swiper-button--next');
      const prevButton = this.querySelector('.swiper-button--prev');
      
      // Se ci sono elementi di navigazione, assicurati che siano nel DOM
      if (slides.length > 1) {
        if (!pagination && !nextButton && !prevButton) {
          //console.log('[Hero Slider] Elementi di navigazione non trovati');
          // Non bloccare l'inizializzazione per questo
        }
      }

      return true;
    }

    disconnectedCallback() {
      this.destroySlider();
    }

    destroySlider() {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
        this.isInitialized = false;
        this.initAttempts = 0;
      }
    }

    initSlider() {
      // Previeni inizializzazioni multiple
      if (this.isInitialized || this.slider) {
        //console.log('[Hero Slider] Già inizializzato o in corso');
        return;
      }

      // Assicurati che ci siano slide da mostrare
      const slides = this.querySelectorAll('.swiper-slide');
      if (slides.length === 0) {
        console.warn('[Hero Slider] Nessuna slide trovata');
        return;
      }

      //console.log(`[Hero Slider] Inizializzazione in corso con ${slides.length} slide`);

      const autoplayOptions = {
        delay: parseInt(this.dataset.autoplayInterval) || 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true // Migliore UX
      };

      try {
        // Forza un reflow prima di inizializzare
        this.offsetHeight;

        this.slider = new Swiper(this, {
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          rewind: false,
          loop: false,
          slidesPerView: 1,
          speed: 600,
          followFinger: true,
          touchRatio: 1,
          threshold: 10,
          watchSlidesProgress: true,
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          resistanceRatio: 0.85,
          navigation: {
            nextEl: '.swiper-button--next',
            prevEl: '.swiper-button--prev'
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (i, className) {
              return `
              <button class="${className}">
                <span>0${i + 1}</span>
                <svg class="square-progress" width="26" height="26">
                  <rect class="square-origin" width="26" height="26" rx="5" ry="5" />
                </svg>
                <svg class="progress" width="18" height="18" style="inset-inline-start: ${0 - ((i * 2.4) + 3.4)}rem">
                  <circle class="circle-origin" r="8" cx="9.5" cy="9.5"></circle>
                </svg>
              </button>
              `;
            }
          },
          autoplay: this.dataset.autoplay === 'true' ? autoplayOptions : false,
          on: {
            init: (swiper) => {
              //console.log('[Hero Slider] Swiper inizializzato con successo!');
              this.isInitialized = true;
              this.handleSlideChange(swiper);
              
              // Se c'era uno slide pending da Shopify, vai lì
              if (this.pendingSlideIndex !== undefined) {
                swiper.slideTo(this.pendingSlideIndex, 600);
                this.pendingSlideIndex = undefined;
              }
              
              // Update con requestAnimationFrame per sincronizzazione
              requestAnimationFrame(() => {
                swiper.update();
                swiper.updateSlides();
                swiper.updateProgress();
                swiper.updateSlidesClasses();
                
                // Secondo update per sicurezza
                requestAnimationFrame(() => {
                  swiper.update();
                });
              });
            },
            slideChange: this.handleSlideChange.bind(this),
            resize: (swiper) => {
              swiper.update();
            },
            progress: (swiper) => {
              // Assicura classi corrette
              swiper.slides.forEach((slide, index) => {
                if (index === swiper.activeIndex) {
                  slide.classList.add('swiper-slide-fully-visible');
                } else {
                  slide.classList.remove('swiper-slide-fully-visible');
                }
              });
            },
            observerUpdate: (swiper) => {
              swiper.update();
            }
          }
        });

        //console.log('[Hero Slider] Swiper creato, attendo inizializzazione...');

      } catch (error) {
        console.error('[Hero Slider] Errore nell\'inizializzazione:', error);
        this.isInitialized = false;
        
        // Retry dopo errore
        setTimeout(() => {
          this.attemptInit('error-retry');
        }, 500);
      }
    }

    // Rinominato da mountSlider per chiarezza
    mountSlider() {
      this.attemptInit('mount-slider-call');
    }

    handleSlideChange(swiper) {
      const headerInner = document.querySelector('.header__inner');
      const heroInners = document.querySelectorAll('.hero__inner');

      if (!headerInner || !heroInners || !heroInners[swiper.activeIndex]) {
        return;
      }

      // Cambia colore header
      const headerTextColor = heroInners[swiper.activeIndex].dataset.headerMenuTextColor;
      if (headerTextColor) {
        document.documentElement.style.setProperty(
          '--transparent-header-menu-text-color',
          headerTextColor
        );
      }

      // Assicura classi slide corrette
      swiper.slides.forEach((slide, index) => {
        if (index === swiper.activeIndex) {
          slide.classList.add('swiper-slide-fully-visible');
        } else {
          slide.classList.remove('swiper-slide-fully-visible');
        }
      });

      // Trigger evento personalizzato per altri componenti
      this.dispatchEvent(new CustomEvent('hero-slide-change', {
        detail: {
          activeIndex: swiper.activeIndex,
          slide: heroInners[swiper.activeIndex]
        }
      }));
    }
  }
  customElements.define('hero-slider', HeroSlider);
}